import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchTreeList, getCompanyHouseList, insertCompanyHouse, fetchHouseTreeList } from '@/api/PMS/treeList/house';
export default {
  props: {
    keyValue: {
      type: Number,
      default: null
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: true,
      defaultProps: {
        children: 'pmsTree',
        label: 'name'
      },
      treeQuery: {
        addIdList: [],
        companyId: 42641,
        op: 0,
        opDate: ''
      },
      treeData: [],
      checkData: [],
      detialList: []
    };
  },
  watch: {
    showDialog: function showDialog(newValue, oldValue) {
      if (newValue) {
        this.init();
      }
    }
  },
  created: function created() {
    // console.log('store',this.$store.state.user.communityId)
    this.init();
  },
  methods: {
    init: function init() {
      this.treeData = [];
      this.checkData = [];
      this.detialList = [];
      this.loadData();
    },
    loadMenuTree: function loadMenuTree(data) {
      var _this = this;

      // 加载树
      var houseIds = [];
      var dataQuery = data ? data : [];

      if (dataQuery.length !== 0) {
        dataQuery.forEach(function (item) {
          houseIds.push(item);
        });
      }

      console.log(data, '11111');
      fetchTreeList({
        flag: 8,
        areaId: this.$store.state.user.communityId
      }).then(function (response) {
        _this.treeData = response.data.data;
        console.log(treeData, 'shusshu');

        _this.treeFormat(_this.treeData);

        _this.loading = false; // if (this.checkedNodes.length > 0) this.$refs.tree.setCheckedKeys(this.checkedNodes)
      }).catch(function (err) {
        console.log('err', err);
        _this.loading = false;
      });
    },
    // 查询已选择的数据
    loadData: function loadData() {
      var _this2 = this;

      var data = [];
      var data2 = [];
      this.loading = true;
      getCompanyHouseList({
        companyId: this.keyValue
      }).then(function (res) {
        // res.data.data.otherBandingHouseList.forEach(e => {
        //   data.push(e.houseId.toString())
        // })
        // res.data.data.myBandingHouseList.forEach(e => {
        //   data2.push(e.houseId.toString())
        // })
        res.data.data.forEach(function (e) {
          data2.push(e.houseId.toString());
        });
        _this2.checkData = data2;
        console.log(_this2.checkData, '66666666');

        _this2.loadMenuTree(data);
      }).catch(function (err) {
        console.log('err', err);
        _this2.loading = false;
      });
    },
    treeFormat: function treeFormat(list) {
      var _this3 = this;

      list.forEach(function (item) {
        _this3.treeChildFormat(item);

        if (item.pmsTree && item.pmsTree.length > 0) {
          _this3.treeFormat(item.pmsTree);
        }
      });
    },
    treeChildFormat: function treeChildFormat(child) {
      child.checkedId = ++this.checkedId;
    },
    renderContent: function renderContent(h, _ref) {
      var _this4 = this;

      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;
      console.log(data, 'bbbbbbbbbbb', node, h, store);

      if (data.flag === '211') {
        if (data.rent == true) {
          console.log(data, '我是房间'); // const arr = []
          // arr.push(data.id)
          // console.log(this.checkData,'woshiarr',arr)
          // this.$set(data,'disabled',true)

          this.checkData.forEach(function (item) {
            // arr.forEach( a => {
            // })
            console.log(item, 'ceshi', data.id);

            if (item == data.id) {
              _this4.$set(data, 'disabled', false);
            } else {// this.$set(data,'disabled',true)
            }
          });
        }
      }

      if (data.flag === '0') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanliquyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '1') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fenzu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '2') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'louyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '21') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'danyuan'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '211') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fangjian'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '212') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanggaowei'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '3') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'cheku'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '31') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'chewei'
          }
        }), h("span", [node.label])]);
      }
    },
    checkChange: function checkChange() {
      var checkedTreeNodes = this.$refs.tree.getCheckedNodes();
      var filterData = checkedTreeNodes.filter(function (item) {
        return item.flag === '211';
      }); // this.detialList = filterData.map(item => {
      //   return {
      //     resourceId: item.id,
      //     flag: item.flag
      //   }
      // })

      this.detialList = filterData.map(function (item) {
        return item.id;
      });
    },
    handCreate: function handCreate() {
      var _this5 = this;

      // if (this.detialList && this.detialList.length > 0) {
      if (this.detialList) {
        // this.$emit('handCancle', true)
        // this.$emit('sendHouseData', this.detialList)
        this.treeQuery.companyId = this.keyValue;
        this.treeQuery.houseList = this.detialList;
        console.log(this.treeQuery, 'this.treeQuery');
        insertCompanyHouse(this.treeQuery).then(function (res) {
          if (res.data.code === 200) {
            _this5.$notify({
              title: '成功',
              message: '绑定房屋成功',
              type: 'success'
            });

            _this5.$emit('handCancle', true);
          }
        }).catch(function (err) {
          console.log('err', err);
        });
      } else {
        this.$message.error('请选择需要绑定的房屋');
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};